import React from "react";

const testimonials = [
  {
    name: "Sarah & Tom Mitchell",
    origin: "London, UK",
    rating: 5,
    text: "Mariner Lodge exceeded every expectation. The sunrise over K2 from our balcony was a moment we will treasure forever. The hosts made us feel like family.",
    avatar: "ST",
    trip: "Summit View Room · July 2024",
    accentClass: "bg-ocean-100 text-ocean-800",
    borderClass: "border-ocean-200",
  },
  {
    name: "Rahul Sharma",
    origin: "Mumbai, India",
    rating: 5,
    text: "Stayed for a week before our K2 base camp trek. The home-cooked Balti food was incredible, the views unreal, and the staff arranged everything seamlessly.",
    avatar: "RS",
    trip: "Alpine Cozy Room · August 2024",
    accentClass: "bg-teal-100 text-teal-800",
    borderClass: "border-teal-200",
  },
  {
    name: "Emma Schneider",
    origin: "Berlin, Germany",
    rating: 5,
    text: "Peaceful, authentic, and breathtakingly beautiful. I came solo and left feeling recharged. The panoramic terrace at golden hour is pure magic.",
    avatar: "ES",
    trip: "Indus River Suite · September 2024",
    accentClass: "bg-sand-100 text-sand-800",
    borderClass: "border-sand-200",
  },
  {
    name: "James & Aiko Tanaka",
    origin: "Toronto, Canada",
    rating: 5,
    text: "Our family of four had the most memorable Pakistan holiday. The kids loved learning about local culture, the parents loved the mountain silence.",
    avatar: "JA",
    trip: "Indus River Suite · October 2024",
    accentClass: "bg-indigo-100 text-indigo-800",
    borderClass: "border-indigo-200",
  },
];

function StarRating({ count }) {
  return (
    <div className="flex gap-0.5" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <svg
          key={i}
          className={`w-4 h-4 ${i < count ? "text-sand-400" : "text-slate-200"}`}
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="section-pad bg-white">
      <div className="container-base">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="section-subtitle mb-3">Guest Reviews</p>
          <h2 className="section-title mb-4">Loved by Adventurers</h2>
          <p className="section-lead">
            Real stories from real guests who came for the mountains and stayed
            for the warmth of Mariner Lodge.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <blockquote
              key={i}
              className={`testimonial-card p-7 rounded-2xl border ${t.borderClass} flex flex-col gap-4`}
            >
              {/* Stars */}
              <StarRating count={t.rating} />

              {/* Quote text */}
              <p className="text-slate-700 text-body-md leading-relaxed italic flex-1">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Attribution */}
              <footer className="flex items-center gap-3 pt-2 border-t border-slate-100">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-body-xs font-bold flex-shrink-0 ${t.accentClass}`}
                  aria-hidden="true"
                >
                  {t.avatar}
                </div>
                <div>
                  <cite className="font-semibold text-slate-900 text-body-sm not-italic">
                    {t.name}
                  </cite>
                  <p className="text-slate-400 text-body-xs">{t.origin}</p>
                  <p className="text-slate-400 text-body-xs">{t.trip}</p>
                </div>
              </footer>
            </blockquote>
          ))}
        </div>

        {/* Overall rating banner */}
        <div className="mt-12 bg-teal-gradient rounded-2xl p-8 text-center text-white">
          <p className="text-body-xs font-semibold uppercase tracking-widest text-teal-200 mb-2">
            Overall Rating
          </p>
          <div className="flex items-center justify-center gap-3 mb-1">
            <span className="font-serif text-5xl font-bold">4.9</span>
            <div className="flex flex-col items-start gap-1">
              <StarRating count={5} />
              <span className="text-teal-200 text-body-xs">from 120+ reviews</span>
            </div>
          </div>
          <p className="text-white/80 text-body-sm mt-3">
            Consistently ranked #1 guest house in Skardu on TripAdvisor &amp; Booking.com
          </p>
        </div>
      </div>
    </section>
  );
}
